import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 구성 관리 스케줄 및 수집 대상을 등록한다.
   * @param  {[type]} params [description]
   * @author jda
   */
  addConfigurationSchedule(params) {
    return axios.post(`${baseUrl}/settings/config-schedule/add-configuration-schedule.do`, params);
  },
  /**
   * 수집 주기 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getObjConfigurationSchedule(params) {
    return axios.post(`${baseUrl}/settings/config-schedule/get-configuration-schedule.do`, params);
  },
  /**
   * 스케쥴을 삭제한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteConfigurationSchedule(params) {
    return axios.post(`${baseUrl}/settings/config-schedule/delete-configuration-schedule.do`, params);
  },
  /**
   * 수집 주기 및 수집 대상을 수정한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateConfigurationSchedule(params) {
    return axios.post(`${baseUrl}/settings/config-schedule/update-configuration-schedule.do`, params);
  },
  /**
   * 스케쥴을 즉시 수행한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  executeSchedule(params) {
    return axios.post(`${baseUrl}/settings/config-schedule/execute-schedule.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/config-schedule.js